import React from 'react';

const UserAvatar = ({ img }) => (
  <img className="db br-100 ba b--black-20 a-c-avt" src={img} alt="avatar" />
);

UserAvatar.defaultProps = {
  img: 'avatar'
};

export default UserAvatar;
